import React from "react";
import { observer } from "mobx-react";
import UsersStore from 'Stores/usersStore';
import TransparentLoadIndicator from "Components/Common/transparentLoadIndicator";
import LoadingIndicator from "Components/Common/LoadingIndicator";
import 'Styles/usersView/syncSyncedProcessModal.scss';
import { GetTaskDescriptionByUserState } from "Utils/CommonFunctions";
import NamedBlock from "Components/Common/NamedBlock";
import ModalWindow from "Components/Common/modalWindow";

class SyncSyncedProcessModal extends React.Component {
    render() {
        var syncStarted =
            UsersStore.usersReloadState != null
            &&
            UsersStore.usersReloadState.inProcess
            ;
        var syncInfoAvailable =
            syncStarted
            &&
            UsersStore.usersReloadState.currentProccessedUserLid != null
            ;

        let usersReloadState = {};
        let currentProcessedUserState = {};

        let currentUserLid = null;
        let usersNamesByLids = UsersStore.listOfUsersToBeLoaded;

        let usersReloadStateProgress =
        {
            loaded: 0,
            total: 0
        };

        let currentUserInfo = <NamedBlock title='Синхронизация пользователя не выполняется'
            className='user-sync-info-named-block' />;
        let usersLines = <div className='list-of-loading-users-placeholder'>Очередь загружается</div>;
        let stopModal = '';

        if (syncInfoAvailable) {
            usersReloadState = UsersStore.usersReloadState;

            currentUserLid = UsersStore.usersReloadState.currentProccessedUserLid;

            currentProcessedUserState = UsersStore.usersReloadStateCurrentProcessedUserState;

            if (UsersStore.doesStopSyncSyncedProcessModalNeedsToBeShown) {
                stopModal = (
                    <ModalWindow
                        canBeClosed={true}
                        header='Синхронизация пользователей'
                        close={UsersStore.CloseStopSyncSyncedProcessModal.bind(UsersStore)}
                        className='stop-sync-synced-process-modal'
                        buttons={[{
                            content: 'Отменить',
                            closer: true
                        }, {
                            content: 'Прервать',
                            onClick: UsersStore.StopSyncSyncedProcess.bind(UsersStore),
                            closer: true
                        }]}>
                        Очередь пользователей будет очищена, а синхронизация текущего пользователя {usersNamesByLids[currentUserLid]} будет выполнена. Вы действительно хотите прервать синхронизацию пользователей?
                    </ModalWindow>
                );
            }

            usersLines =
                usersReloadState.currentStateOfUsersQueueExceptProcessedUser.length == 0
                    ?
                    <div className='list-of-loading-users-placeholder'>Очередь пуста</div>
                    :
                    usersReloadState.currentStateOfUsersQueueExceptProcessedUser.map(userLid =>
                        <div key={userLid}
                            className="smr-table-line text-overflow-dotted">
                            {usersNamesByLids[userLid]}
                        </div>
                    );

            currentUserInfo = (
                <NamedBlock title={`Выполняется синхронизация пользователя ${usersNamesByLids[currentUserLid]}`}
                    className='user-sync-info-named-block'>
                    <div className='sync-synced-process-modal-current-user-state'>
                        <div className='sync-synced-process-modal-current-user-state-info-with-indicator'>
                            <div className='sync-synced-process-modal-current-user-state-info-with-indicator-task-description'>
                                <div>{GetTaskDescriptionByUserState(currentProcessedUserState, true)} {`[${currentProcessedUserState.documentsLoadProgressByFolders.loaded}/${currentProcessedUserState.documentsLoadProgressByFolders.total}]`}</div>
                                <div>Общий ход выполнения: {`[${currentProcessedUserState.documentsLoadProgressFull.loaded}/${currentProcessedUserState.documentsLoadProgressFull.total}]`}</div>
                            </div>
                            <TransparentLoadIndicator processInfo={{ loaded: currentProcessedUserState.documentsLoadProgressFull.loaded, total: currentProcessedUserState.documentsLoadProgressFull.total }} />
                        </div>
                    </div>
                </NamedBlock>
            );

            usersReloadStateProgress.loaded = usersReloadState.progress.loaded;
            usersReloadStateProgress.total = usersReloadState.progress.total;
        }

        let totalInfo = (
            <NamedBlock title='Выполняется синхронизация пользователей'
                className='common-info-named-block'>
                <div className='total-sync-info'>
                    {
                        (syncInfoAvailable)
                            ?
                            <div className='total-sync-info-title'>
                                <div>Синхронизировано пользователей: {usersReloadState.usersLoadedCount} из {usersReloadState.usersQueueInitialCount}</div>
                                <div>Всего синхронизировано {usersReloadStateProgress.loaded} из {usersReloadStateProgress.total} РК/РКПД</div>
                            </div>
                            :
                            <div className='total-sync-info-title'>Подготовка списка синхронизируемых пользователей</div>
                    }
                    <LoadingIndicator
                        loaded={usersReloadStateProgress.loaded}
                        total={usersReloadStateProgress.total}
                        runner={usersReloadStateProgress.total === 0} />
                </div>
            </NamedBlock>
        );

        let usersQueue = (
            <NamedBlock title='Пользователи в очереди'
                className='user-queue-named-block'>
                <div className='sync-synced-process-modal-data-container-table-container'>
                    <div className='smr-table'>
                        <div className='lines-container overflowing-element'>
                            {usersLines}
                        </div>
                    </div>
                </div>
            </NamedBlock>
        );

        return (
            <div className='sync-synced-process-modal-data-container'>
                {totalInfo}
                {currentUserInfo}
                {usersQueue}
                {stopModal}
            </div>
        );
    }
}

export default observer(SyncSyncedProcessModal);